<div (click)="closeModal()" class="backdrop"></div>

<div class="dynamic-modal-wrapper">
  <ng-container #dynamicModalContainer></ng-container>
</div>
